import gql from "graphql-tag"

import { VARIANT_FRAGMENT } from "@app/graphql/fragments/variantFragment"

export const VARIANT_WITH_PRODUCT_FRAGMENT = gql`
  fragment AppVariantWithProductFragment on ProductVariant {
    ...VariantFragment
    product {
      description
      handle
      id
      productType
      tags
      title
      vendor
    }
  }
  ${VARIANT_FRAGMENT}
`
